<template>
  <div>
    <div :class="`theme-main-menu sticky-menu theme-menu-five fixed`">
      <div class="d-flex align-items-center justify-content-center">
        <div class="logo">
          <img src="../../assets/images/logo/logo_with_text_2.svg" alt="logo" />
          <router-link to="/" class="logo-overlay-link"></router-link>
        </div>

        <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
          <div class="nav-container">
            <button
                class="navbar-toggler"
                data-bs-toggle="collapse"
                data-bs-target="#collapsibleNavbar"
                :class="menuActive ? 'navbar-toggler open' : 'navbar-toggler'"
                @click="menuActive = !menuActive"
            >
              <span></span>
            </button>
            <div class="navbar-collapse collapse" id="collapsibleNavbar">
              <div class="d-lg-flex justify-content-between align-items-center">
                <ul
                    class="navbar-nav main-side-nav font-roboto-medium"
                    id="one-page-nav"
                >
                  <!--actual section-->
                  <li class="nav-item">
                    <a href="https://demo.saasconstruct.com" target="_blank" rel="noopener noreferrer" class="nav-link plausible-event-name=DemoClick">{{ $t('header.demo') }}</a>
                  </li>
                  <li class="nav-item">
                    <router-link to="/#pricing" class="nav-link">{{ $t('header.pricing') }}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/blog" class="nav-link">{{ $t('header.blog') }}</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/documentation/get-started" class="nav-link">{{ $t('header.documentation') }}</router-link>
                  </li>
                  <li class="nav-item">
                    <button class="nav-link plausible-event-name=BuyClick" @click="createCheckoutSession">

                      <span v-if="creatingSession || fetchingOneTimePaymentsMade" class="spinner"></span>
                      <span v-else>{{ $t('intro.getStarted') }}</span>
                    </button>
                  </li>
                </ul>
                <div class="d-lg-flex align-items-center right-widget font-roboto-medium">
                  <ul class="right-button-group d-flex align-items-center justify-content-center">
                    <li>
                      <router-link
                          v-if="store.isAuthenticated"
                          to="/account"
                          class="header-action"
                      >{{ $t('header.account') }}
                      </router-link>
                      <router-link
                          v-else
                          to="/signin"
                          class="header-action"
                      >{{ $t('header.login') }}
                      </router-link>
                    </li>
                    <li v-if="showLanguageDropdown">
                      <SaasInfraLanguageDropdown/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useAuthStore} from "@/store/auth";
import SaasInfraLanguageDropdown from "@/components/languages/SaasInfraLanguageDropdown.vue";
import {useRoute} from "vue-router";
import usePricingProducts from "@/composables/usePricingProducts";
import {isLemonSqueezy, isStripe} from "@/composables/useEnvironment";
import useCreateCheckoutSessionForOneTimePaymentsStripe
  from "@/composables/useCreateCheckoutSessionForOneTimePaymentsStripe";
import useCreateCheckoutSessionForOneTimePaymentsLemonSqueezy
  from "@/composables/useCreateCheckoutSessionForOneTimePaymentsLemonSqueezy";
import useFetchOneTimePaymentsMade from "@/composables/useFetchOneTimePaymentsMade";
import {useOneTimePaymentsStore} from "@/store/oneTimePayments";


export default {
  name: "SaasInfraHeader",
  components: {
    SaasInfraLanguageDropdown
  },

  setup() {
    const store = useAuthStore()
    const isSticky = ref(false)
    const menuActive = ref(false)
    const route = useRoute();
    const creatingSession = ref(false)
    const {fetchingOneTimePaymentsMade} = useFetchOneTimePaymentsMade();
    const oneTimePaymentsStore = useOneTimePaymentsStore();

    const {getMostPopularProduct} = usePricingProducts();

    let createCheckoutSessionForOneTimePayment;
    let createCheckoutSessionForOneTimePaymentWithoutLogin;

    if (isStripe()) {
      const {
        createCheckoutSessionForOneTimePaymentStripe,
        createCheckoutSessionForOneTimePaymentWithoutLoginStripe,
      } = useCreateCheckoutSessionForOneTimePaymentsStripe();

      createCheckoutSessionForOneTimePayment = createCheckoutSessionForOneTimePaymentStripe;
      createCheckoutSessionForOneTimePaymentWithoutLogin = createCheckoutSessionForOneTimePaymentWithoutLoginStripe;
    }

    if (isLemonSqueezy()) {
      const {
        createCheckoutSessionForOneTimePaymentLemonSqueezy,
        createCheckoutSessionForOneTimePaymentWithoutLoginLemonSqueezy,
      } = useCreateCheckoutSessionForOneTimePaymentsLemonSqueezy();

      createCheckoutSessionForOneTimePayment = createCheckoutSessionForOneTimePaymentLemonSqueezy;
      createCheckoutSessionForOneTimePaymentWithoutLogin = createCheckoutSessionForOneTimePaymentWithoutLoginLemonSqueezy;
    }

    const createCheckoutSession = async () => {
      const item = getMostPopularProduct()
      if (store.isAuthenticated) {
        await createCheckoutSessionForOneTimePayment(item, creatingSession);
      } else {
        await createCheckoutSessionForOneTimePaymentWithoutLogin(item, creatingSession);
      }
    }


    const handleSticky = () => {
      isSticky.value = window.scrollY > 80;
    };

    onMounted(async () => {
      window.addEventListener("scroll", handleSticky);
    });


    const showLanguageDropdown = computed(() => {
      // Check the isTranslated property in the current route's meta
      return route.meta.isTranslated !== false;
    });


    return {
      store,
      menuActive,
      showLanguageDropdown,
      createCheckoutSession,
      oneTimePaymentsStore,
      creatingSession,
      fetchingOneTimePaymentsMade
    };
  },
};
</script>


<style scoped>
.logo {
  position: relative;
  display: inline-block;
}

.logo-overlay-link {
  position: absolute;
  top: 60px;
  left: 0;
  width: 150px;   /* Your desired clickable area width */
  height: 40px;   /* Your desired clickable area height */
  z-index: 2;
  cursor: pointer;
}

</style>
